import React, { Component } from "react";
import TextField from "@mui/material/TextField";
import DataStore from "./../../../stores/DataStore";
/**
 * @class
 * Für Zahleneinträge
 * @name NumberTextFieldAttribute
 * @implements {Attribute}
 */
class NumberTextFieldAttribute extends Component {
  onChange(evt) {
    const { attribute: { onChange, value = "" } = {} } = this.props;
    onChange(evt.target.value);
  }

  getValue() {
    return DataStore.attributeValues[this.id].value;
  }

  getValueString() {
    const { value = "" } = DataStore.attributeValues[this.id];
    return value.toString();
  }

  getSummaryDisplay() {
    return <div>{this.getValueString()}</div>;
  }

  render() {
    const {
      attribute: {
        id = "",
        name = "",
        attributeOption: { Field = TextField, InputProps = {} },
        attributeModul,
      } = {},
    } = this.props;
    attributeModul.holdedAttribute = this;
    this.id = id;
    return (
      <Field
        disabled={DataStore.attributeValues[this.id].readOnly}
        key={id}
        id={id}
        style={{
          flexGrow: 1,
          marginRight: "5px",
        }}
        name={name}
        label={name}
        type="number"
        step="1"
        // style={{ float: 'right' }}
        // margin="dense"
        onChange={(evt) => this.onChange(evt)}
        value={DataStore.attributeValues[this.id].value}
        {...InputProps}
      />
    );
  }
}

export default NumberTextFieldAttribute;
